'use strict';
import {SERVER_STATUS_STATE, TRACK_LOCATION_NAME} from '../actions';

export const STATE_NAME = 'settings';

/**
 * CODE_TAG[Global-state-shape-aware]
 * @param rootState
 * @return {*}
 */
export function getSettingsState(rootState) {
  return rootState[STATE_NAME];
}

/**
 * @param rootState
 * @return {ServerStatusState}
 */
export function getServerStatus(rootState) {
  return getSettingsState(rootState)[SERVER_STATUS_STATE];
}

/**
 * @param rootState
 * @return {Boolean}
 */
export function getIsOnline(rootState) {
  return getServerStatus(rootState).isOnline;
}

/**
 * @param rootState
 * @return {TrackLocationState}
 */
export function getTrackLocation(rootState) {
  return getSettingsState(rootState)[TRACK_LOCATION_NAME];
}

/**
 * @param rootState
 * @return {TrackLocationState}
 */
export function getTrackLocationSafe(rootState) {
  const settingsState = getSettingsState(rootState || {});
  return settingsState ? settingsState[TRACK_LOCATION_NAME] : void 0;
}

/**
 * @param rootState
 * @param {String} key
 * @return {Boolean}
 */
export function isTracking(rootState, key) {
  return Boolean(getTrackLocation(rootState).listeners[key]);
}

/**
 * @param rootState
 * @return {?UpdatePositionPayload}
 */
export function getCachedPayload(rootState) {
  return getTrackLocation(rootState).lastPositionPayload;
}



// WEBPACK FOOTER //
// ./src/js/settings/reducers/state.js